<div id="wrapper" class="wrapper clearfix">
    <div class="container pairblank">
      <div class="page__section"> 
            <nav class="breadcrumb breadcrumb_type5" aria-label="Breadcrumb">
                <ol class="breadcrumb__list r-list">
                    <li class="breadcrumb__group">
                        <a [routerLink]="['/compnay-news']" class="breadcrumb__point r-link" title="Analiz">Şirket Haberleri</a>
                        <span class="breadcrumb__divider" aria-hidden="true">›</span>
                    </li>
                    <li class="breadcrumb__group">
                        <span class="breadcrumb__point" aria-current="page">{{detail?.title}}</span>
                    </li>
                </ol>
            </nav>
        </div>
    </div>
<section id="tabs" class="project-tab tab-edit">
    <div class="container ">
        <div class="row">
            <div class="col-sm-12 col-md-12 col-lg-8 mb-30-xs mb-30-sm">
                <div class="row">
                    <div class="col-sm-12 col-md-12 col-lg-12">
                        <div style="text-align: center;margin: 30px;">
                            <h3 class="h1 news-detail-title">{{detail?.title}}<br></h3>
                            <h4 class="h2" style="text-align: left; font-size: 20px;">
                                <span [innerHTML]="detail?.subTitle  | keepHtml"></span>
                            </h4>
                            <div [innerHTML]="detail?.info  | keepHtml" style="text-align: left;"></div>
                        </div>
                    </div>
                </div>
                <div class="widget market-pricing market-list card mb-3" style="position: relative; padding:10px;">
                    <div class="row">
                     <div class="col-4"style="width:auto;height:auto;"><img loading="lazy" src="{{domainURL}}halka-arz.webp" alt="Halka Arz Haberler" title="Halka Arz Haberler"
                        ></div>
                    <div class="col-8"><h3 class="h6"><strong>Halka Arz Haberleri </strong></h3>ve borsa haberlerini <a href="/news"> Haberler</a> sayfamızdan okuyabilirsiniz.</div>
                    <div class="w-100"></div>
                    <br>
                    <p>Şirketlerin haberlerine <strong><a href="/company-news">Şirket Haberleri </a></strong>sayfamızdan ulaşabilirsiniz.</p>
                    </div>
                </div>
                <br>
            </div>
            <div class="col-sm-12 col-md-12 col-lg-4">
                <app-draft-month [toYear]="toYear"></app-draft-month>
                <app-draft-dividend [toYear]="toYear"></app-draft-dividend>
                <app-summary-info></app-summary-info>
                <app-summary-analysis [imageStatus]="true" [count]="5"></app-summary-analysis>
            </div>
        </div>
    </div>
</section>
</div>